/**
 * Copyright (C) 2021 Trend Micro Inc. All rights reserved.
 *
 * This is a helper module to help interface the data exposed from Cloud One Common Frontends
 */

export const LocalStorageKeys = {
  LoginFrom: 'loginFrom',
};
export const V1ES_FLAG = 'V1ES';
export const C1WS_FLAG = 'C1WS';

export const c1TokenReadViaSessionStorage = () => {
  return getC1CShellState().c1Token?.token;
};

export const c1UserTypeReadViaSessionStorage = () => {
  return getC1CShellState().c1UserDetails?.type;
};

export const getC1CShellState = () => {
  const c1cShellState = sessionStorage.getItem('C1C_Shell_State');
  if (c1cShellState === null) {
    return {};
  }
  return JSON.parse(c1cShellState);
};

export const DEFAULT_REGION = 'us-1';
// Returns the region prefix to be included in urls.
// In the case of the default region it returns an empty string
//
// If we cannot reliably determine the region, throws an error rather than
// returning undefined to make the difference between default region and error
// obvious
export const getRegionPrefixViaSessionStorage = () => {
  const region = getAccountInfoFromSessionStorage(
    getC1CShellState().c1Accounts?.c1AccountID,
    'region'
  );

  return getRegionPrefixFromRegion(region);
};

export const getRegionPrefixFromRegion = (region?: string) => {
  let regionPrefix: string;
  if (!region) {
    throw 'Could not determine region';
  } else if (region === DEFAULT_REGION) {
    regionPrefix = '';
  } else {
    regionPrefix = region;
  }

  return regionPrefix;
};

export const getAccountInfoFromSessionStorage = (accountID, key) => {
  return getC1CShellState().c1Accounts?.c1AccountsList?.find(
    (account) => account.id === accountID
  )?.[key] as string | undefined;
};

export const featureFlagFakeCognito = () => {
  return localStorage.getItem('C1C_WORKLOAD_TREAT_WORKLOAD_USERS_AS_COGNITO')
    ? JSON.parse(localStorage.getItem('C1C_WORKLOAD_TREAT_WORKLOAD_USERS_AS_COGNITO') || 'false')
    : false;
};

export const featureFlagSS0v2Enabled = () => {
  return localStorage.getItem('C1C_SSO_V2_ENABLED')
    ? JSON.parse(localStorage.getItem('C1C_SSO_V2_ENABLED') || 'false')
    : false;
};

// TODO: Remove the FeatureFlag check with C1C-11968
const checkGovCloudRegion = () => {
  const isGovCloudDeploymentTarget = ['govcloud-prod', 'govcloud-staging'].includes(
    DEPLOYMENT_TARGET
  );
  const hasGovCloudFeatureFlag = JSON.parse(
    localStorage.getItem('C1C_GOV_CLOUD_ENABLED') || 'false'
  );
  return isGovCloudDeploymentTarget || hasGovCloudFeatureFlag;
};
export const isGovCloudRegion = checkGovCloudRegion();

export const wait = async (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const hasProdLogsEnabled = JSON.parse(
  localStorage.getItem('C1C_PROD_LOGS_ENABLED') || 'false'
) as boolean;
